<template>
  <div class="exr-pdt-item">
    <div :class="['exr-item-wrap', 'exr-item-left', 'exr-item-' + config.leftItems]" v-if="leftComp">
      <component v-bind="leftComp" :value="leftItem"/>
    </div>
    <div :class="['exr-item-wrap', 'exr-item-right', 'exr-item-' + config.rightItems]" v-if="rightComp">
      <component v-bind="rightComp" :value="rightItem"/>
    </div>
    <slot name="append"></slot>
  </div>
</template>

<script>

/* eslint-disable */

import PdtItemAudio from "./audio.vue";
import PdtItemAudio2 from "./audio2.vue";
import PdtItemImage from "./image.vue";
import PdtItemImage2 from "./image2.vue";
import PdtItemPinyin from "./pinyin.vue";
import PdtItemTranslation from "./translation.vue";
import PdtItemWords from "./words.vue";
import PdtItemWords2 from "./words2.vue";

//从词汇库中选择数据
const source1Config = {
  left: {
    words: {is: 'PdtItemWords'},
    pinyin: {is: 'PdtItemWords'},
    words_pinyin: {is: 'PdtItemWords', showPinyin: true},
    translation: {is: 'PdtItemTranslation', readonly: true},
    image: {is: 'PdtItemImage'},
    audio: {is: 'PdtItemAudio'},
    'audio|image': {is: 'PdtItemWords', showAudio: true},
    'audio|translation': {is: 'PdtItemWords', showAudio: true},
  },
  right: {
    words: {is: 'PdtItemWords'},
    pinyin: {is: 'PdtItemPinyin'},
    words_pinyin: {is: 'PdtItemWords', showPinyin: true},
    translation: {is: 'PdtItemTranslation', readonly: true},
    image: {is: 'PdtItemImage'},
    audio: {is: 'PdtItemAudio'},
    'image|audio': {is: 'PdtItemWords', showAudio: true},
    'translation|audio': {is: 'PdtItemWords', showAudio: true},
  }
}

//手动录入词汇数据
const source2Config = {
  left: {
    words: {is: 'PdtItemWords2'},
    pinyin: {is: 'PdtItemPinyin'},
    words_pinyin: {is: 'PdtItemWords2', showPinyin: true},
    translation: {is: 'PdtItemTranslation'},
    image: {is: 'PdtItemImage2'},
    audio: {is: 'PdtItemAudio2'},
  },
  right: {
    words: {is: 'PdtItemWords2'},
    pinyin: {is: 'PdtItemPinyin'},
    words_pinyin: {is: 'PdtItemWords2', showPinyin: true},
    translation: {is: 'PdtItemTranslation'},
    image: {is: 'PdtItemImage2'},
    audio: {is: 'PdtItemAudio2'},
  }
}

export default {
  name: "PdtItem",
  components: {
    PdtItemAudio,
    PdtItemAudio2,
    PdtItemImage,
    PdtItemImage2,
    PdtItemPinyin,
    PdtItemTranslation,
    PdtItemWords,
    PdtItemWords2,
  },
  props: {
    leftItem: Object,
    rightItem: Object,
    config: Object
  },
  computed: {
    opts() {
      return this.config.source == 1 ? source1Config : source2Config;
    },
    leftComp() {
      const opt = {...this.opts.left};
      const {leftItems: left, rightItems: right} = this.config;
      return opt[left + '|' + right] || opt[left + '|*'] || opt[left];
    },
    rightComp() {
      const opt = {...this.opts.right};
      const {leftItems: left, rightItems: right} = this.config;
      return opt[left + '|' + right] || opt['*|' + right] || opt[right];
    }
  },
  methods: {
    handleSelectWord(item, word) {
      if (this.leftItem === item) {
        if(this.config.rightItems !== 'words' && this.config.rightItems !== 'words_pinyin') {
          this.$emit('update:rightItem', {...item, type: this.rightItem.type});
        }
      } else {
        if(this.config.leftItems !== 'words' && this.config.leftItems !== 'words_pinyin') {
          this.$emit('update:leftItem', {...item, type: this.leftItem.type});
        }
      }
    }
  }
}
</script>